import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fuzhi",
  "use": "icon-fuzhi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fuzhi\"><path d=\"M749.714286 219.428571h-694.857143A54.857143 54.857143 0 0 0 0 274.285714v694.857143A54.857143 54.857143 0 0 0 54.857143 1024h694.857143a54.857143 54.857143 0 0 0 54.857143-54.857143v-694.857143A55.222857 55.222857 0 0 0 749.714286 219.428571zM694.857143 914.285714H109.714286V329.142857h585.142857zM969.142857 0h-694.857143A54.857143 54.857143 0 0 0 219.428571 54.857143V182.857143h109.714286V109.714286h585.142857v585.142857h-73.142857v109.714286h128a54.857143 54.857143 0 0 0 54.857143-54.857143v-694.857143A54.857143 54.857143 0 0 0 969.142857 0zM219.428571 457.142857h365.348572v109.714286H219.428571zM219.428571 676.571429h365.348572v109.714285H219.428571z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fuzhi.svg
// module id = oYNf
// module chunks = 16